import * as types from "./leaderboard.constant";

const defaultState = { gameId:null , language:"en" , className:"ltr text-left" , items:null , serverError:null
};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.LEADERBOARD_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.LEADERBOARD_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
